import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { HomeComponent } from './home.component';
import { WidgetService } from './widget/widget.service';
import { routing } from "./home.routes";
import {  ApplicationRef, CUSTOM_ELEMENTS_SCHEMA ,NO_ERRORS_SCHEMA} from '@angular/core';
import { AgmCoreModule} from "@agm/core";


@NgModule({
  
    imports: [
        routing,
        SharedModule,AgmCoreModule],
    providers: [WidgetService],
    declarations: [HomeComponent],
    schemas:  [ CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA ],
    
    
})
export class HomeModule {

    
}


// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/home/home.module.ts